import { render, staticRenderFns } from "./DevicesView.vue?vue&type=template&id=45b94e81&scoped=true"
import script from "./DevicesView.vue?vue&type=script&lang=js"
export * from "./DevicesView.vue?vue&type=script&lang=js"
import style0 from "./DevicesView.vue?vue&type=style&index=0&id=45b94e81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b94e81",
  null
  
)

export default component.exports